// extracted by mini-css-extract-plugin
export default {"area":"TextArea_area__tA0Zq"};